// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/ContentTable.js


import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

const ContentTable = ({ travelData, onEditTravel, onDelete, searchQuery, pageLength, currentPage, setCurrentPage, totalCount }) => {
  const filteredData = travelData.filter(travel =>
    travel.Job_Name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(totalCount / pageLength);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map(travel => (
            <tr key={travel.key}>
              <td>{travel.Job_ID}</td>
              <td>{travel.Job_Name}</td>
              <td>{travel.Job_Date}</td>
              <td>
                <button className="btn btn-sm btn-primary me-2" onClick={() => onEditTravel(travel.Job_ID)}>
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button className="btn btn-sm btn-danger" onClick={() => onDelete([travel.Job_ID])}>
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
          </li>
          {[...Array(totalPages)].map((_, index) => (
            <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
              <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ContentTable;